module.exports = __webpack_public_path__ + "static/media/level2_flag.64229ca8.svg";